import { createTranslations } from '@npco/common-utils-translations'

export const savingsAccountContentTranslations = createTranslations({
  title: 'Introducing {lineBreak}Zeller Savings Account',
  account: 'Zeller Savings Account',
  description:
    'Grow your business savings faster with a great interest rate, while having access to your funds at any time.',
  point1: 'Earn up to {effectiveInterestRate}% p.a.* interest.',
  point2: 'A higher rate than any of the big-4 banks as at 6/12/23.',
  point3: 'No minimum balance and no account fees.',
  point4: 'Activate instantly by providing your Tax File Number.',
  interestHeading: 'Receive Bonus Interest',
  interestDescription:
    'Receive {bonusEmphasis} bonus interest on top of our standard variable rate of {baseEmphasis} for the first {bonusLengthInDays} days after you activate.',
  bonusEmphasis: '{bonusInterestRate}% p.a.*',
  baseEmphasis: '{baseInterestRate}% p.a.*',
  termsApply: 'Terms apply.',
  interestHeadingMarch: 'Triple your interest this March.',
  interestDescriptionMarch:
    'Earn an amazing {interestRate} standard variable rate by adding funds to Zeller Savings Account. Limited time offer, ends 31 March 2024.',
})
